import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, Button, showNotification, refreshView as refreshViewAction } from 'react-admin';
import compose from 'recompose/compose';

import request from '../../../../network/request';
import resourceConfig from './config';
import checkDocumentBeforeSend from '../../../../utils/checkDocumentBeforeSend';

class SendRemarkButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
      const { showNotification, record, refreshView, translate } = this.props;

      if (!checkDocumentBeforeSend(record, { showNotification, translate })) {
        return;
      }

        this.setState({
          executing: true
        });
        let data = {
          id: record.id
        }
        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: '/admin/return/func/send',
            urlParams: data,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.sendOut.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.sendOut.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.sendOut.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default compose(
  translate,
  connect(undefined, { 
    showNotification, 
    refreshView: refreshViewAction 
  })
)(SendRemarkButton);